module.exports = __webpack_public_path__ + "static/media/gatsby.f422e499.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Skills/images/gatsby.png
// module id = 113
// module chunks = 0